import { reducer } from "ts-action";
import { updateStoreViralitySettingsAction } from "../../../constants";
import { withLoadingReducer } from "../../../Components/Pickup/redux-store/reducers/withLoadingState";
export const updateStoreViralitySettingsReducer = withLoadingReducer(
  reducer([], {}),
  updateStoreViralitySettingsAction
);
